import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import { checkIsEmail, checkIsPhone } from '../../utils/validation'
import {
  checkEmailExist,
  checkPhoneExist,
  ICheckEmailOrPhoneResponse,
} from '../../utils/api'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface IEmailOrPhoneField {
  classId?: number
  courseId?: number
  value: string
  type: 'email' | 'phone'
  onChange: (value: string) => void
  existedData: ICheckEmailOrPhoneResponse
  onExistedChange: (value: ICheckEmailOrPhoneResponse) => void
  isInvalid: boolean
  byConfirmationCode?: boolean
}

function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

const EmailOrPhoneField: FC<IEmailOrPhoneField> = ({
  courseId,
  classId,
  value,
  type,
  onChange,
  isInvalid,
  existedData,
  onExistedChange,
  byConfirmationCode = false,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const debouncedValue = useDebounce(value, 500)

  useEffect(() => {
    if (
      (type === 'email' && checkIsEmail(value)) ||
      (type === 'phone' && checkIsPhone(value))
    ) {
      setIsLoading(true)
    }
  }, [value])

  useEffect(() => {
    const check = async () => {
      if (
        (type === 'email' && checkIsEmail(debouncedValue)) ||
        (type === 'phone' && checkIsPhone(debouncedValue))
      ) {
        const check = type === 'phone' ? checkPhoneExist : checkEmailExist
        const existed = await check(debouncedValue, courseId, classId)
        onExistedChange(existed)
      }
      setIsLoading(false)
    }
    check()
  }, [debouncedValue])

  return (
    <div className={cn.wrapper}>
      <div className={cn.row}>
        <TextField
          className={cn.inputField}
          placeholder={type === 'phone' ? 'Номер телефона' : 'Email'}
          value={value}
          type={type === 'email' ? 'email' : 'tel'}
          onChange={onChange}
          isInvalid={isInvalid}
        />
        {isLoading && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
      </div>
      {value && !isInvalid && !existedData.hasCourse && (
        <div className={cn.description}>
          {!!existedData?.user ? (
            existedData?.roles?.includes('children') ? (
              `Курс добавится в существующий личный кабинет, привязанный ${
                type === 'email' ? 'к этой почте' : 'к этому номеру'
              }`
            ) : (
              <span style={{ color: 'crimson' }}>
                Данная почта привязана к личному кабинету сотрудника/родителя,
                впишите другую
              </span>
            )
          ) : byConfirmationCode ? (
            <span>
              <span style={{ fontWeight: 600 }}>Логином</span> для личного
              кабинета будет введенный вами номер
              <span style={{ fontWeight: 600 }}> телефона</span> а
              <span style={{ fontWeight: 600 }}> паролем</span> временный
              <span style={{ fontWeight: 600 }}> код подтверждения</span>
            </span>
          ) : type === 'email' ? (
            `Логин и пароль для личного кабинета будут отправлены на указанную почту`
          ) : (
            `Логином и паролем для личного кабинета будут введенные здесь данные(Номер телефона - логином, придуманный пароль - паролем)`
          )}
        </div>
      )}
    </div>
  )
}

export default EmailOrPhoneField
